import { render, staticRenderFns } from "./ManagerLeadHistory.vue?vue&type=template&id=4874b5d8&scoped=true&"
import script from "./ManagerLeadHistory.vue?vue&type=script&lang=js&"
export * from "./ManagerLeadHistory.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-history.scss?vue&type=style&index=0&id=4874b5d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874b5d8",
  null
  
)

export default component.exports